module.exports = __webpack_public_path__ + "img/certification.409867d8.png";